export interface InstallPrompt extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}
let prompt: InstallPrompt | null = null;
const listeners = new Set<() => void>();
const changed = () => { for (const listener of listeners) listener(); };
export const subscribeInstall = (listener: () => void) => { listeners.add(listener); return () => { listeners.delete(listener); }; };
export const installAvailable = () => prompt !== null;
export function captureInstallPrompt(target: Window = window): void {
  target.addEventListener('beforeinstallprompt', event => { event.preventDefault(); prompt = event as InstallPrompt; changed(); });
  target.addEventListener('appinstalled', () => { prompt = null; changed(); });
}
export async function installSidetone(): Promise<'accepted' | 'dismissed' | 'unavailable'> {
  const event = prompt;
  if (!event) return 'unavailable';
  prompt = null;
  changed();
  try { await event.prompt(); return (await event.userChoice).outcome; } catch { return 'unavailable'; }
}
